{
  "de": {
    "history": {
      "heading": {
        "title": "Meine Historie"
      },
      "empty": {
        "noHistory": "Du hast noch keine Bestellungen. Stöbere doch mal in den Fortbildungen."
      },
      "links": {
        "allCourses": "Alle Fortbildungen im Katalog"
      },
      "group": {
        "heading": {
          "title": "Gruppen",
          "group": "Gruppe",
          "access": "Zugriff",
          "link": "Link",
          "actions": "Aktionen"
        },
        "links": {
          "goToGroup": "Zur Gruppe",
          "myMaterial": "Mein Material",
          "editMaterial": "Projektarbeit bearbeiten",
          "createMaterial": "Projektarbeit einreichen",
          "downloadCertificate": "Zertifikat herunterladen",
          "adminArea": "Verwaltungsbereich"
        }
      },
      "course": {
        "heading": {
          "title": "Meine Fortbildungen",
          "course": "Fortbildung",
          "access": "Zugriff",
          "certificate": "Zertifikat"
        },
        "links": {
          "downloadCertificate": "Zertifikat herunterladen"
        },
        "infos": {
          "missingProcess": "Bis zum Zertifikat fehlen:"
        }
      }
    }
  }
}
